
const fields = [

		{
			step: 1,
			name:'judicial_officer',
			label:'Name of Judicial Officer',
			type:'text',
			values:'',
			readonly:false,
			layout:'col s12'
		},
		{
			step:2, 
			label:'Understanding of the Principles of Law and Jurisprudence',
			type: 'group',
			name:'understanding_principles',
			layout:'row',
			options:[
				{
				//	step: 2,
					id:1,
					name:'understanding_principles',
					label:'Understanding of the Principles of Law and Jurisprudence',
					type:'radio',
					options: [
						{
							label: '1',
							value: 1
						},
						{
							label: '2',
							value: 2
						},
						{
							label: '3',
							value: 3
						},
						{
  label: '4',
  value: 4
},
{
  label: '5',
  value: 5
},
						{
							label: 'Unable To State',
							value: 'Unable To State'
						},
					],
					values: new Object,
					readonly:false,
					layout:'col s12 clear'
				},
				{
					id:2,
				//	step: 2,
					label:'Additional Comments',
					name:'comments',
					type:'text_area',
					values:'',
					layout:'col s12',
					readonly:false,
				},
			]
		},
		{
			step:3, 
			label:'Knowledge of the rules of evidence and of court practice and procedure.',
			type: 'group',
			name:'knowledge_of_rules',
			layout:'row',
			options:[
				{
					id:4,
					name:'knowledge_of_rules',
					label:'Knowledge of the rules of evidence and of court practice and procedure.',
					type:'radio',
					options: [
						{
							label: '1',
							value: 1
						},
						{
							label: '2',
							value: 2
						},
						{
							label: '3',
							value: 3
						},
						{
  label: '4',
  value: 4
},
{
  label: '5',
  value: 5
},
						{
							label: 'Unable To State',
							value: 'Unable To State'
						},
					],
					values: new Object,
					readonly:false,
					layout:'col s12 clear'
				},
				{
					id:5,
					label:'Additional Comments',
					name:'comments',
					type:'text_area',
					values:'',
					layout:'col s12',
					readonly:false,
				},
			]
		},
		{
			step:4, 
			label:'Second Judgment.',
			type: 'group',
			name:'sound_judgment',
			layout:'row',
			options:[
				{
					id:6,
					name:'sound_judgment',
					label:'Second Judgment',
					type:'radio',
					options: [
						{
							label: '1',
							value: 1
						},
						{
							label: '2',
							value: 2
						},
						{
							label: '3',
							value: 3
						},
						{
  label: '4',
  value: 4
},
{
  label: '5',
  value: 5
},
						{
							label: 'Unable To State',
							value: 'Unable To State'
						},
					],
					values: new Object,
					readonly:false,
					layout:'col s12 clear'
				},
				{
					id:7,
					label:'Additional Comments',
					name:'comments',
					type:'text_area',
					values:'',
					layout:'col s12',
					readonly:false,
				},
			]
		},
		{
			step:5, 
			label:'Intellectual and Analytical Ability.',
			type: 'group',
			name:'intellectul_analytical_ability',
			layout:'row',
			options:[
				{
					id:8,
					name:'intellectul_analytical_ability',
					label:'Intellectual and Analytical Ability ',
					type:'radio',
					options: [
						{
							label: '1',
							value: 1
						},
						{
							label: '2',
							value: 2
						},
						{
							label: '3',
							value: 3
						},
						{
  label: '4',
  value: 4
},
{
  label: '5',
  value: 5
},
						{
							label: 'Unable To State',
							value: 'Unable To State'
						},
					],
					values: new Object,
					readonly:false,
					layout:'col s12 clear'
				},
				{
					id:9,
					label:'Additional Comments',
					name:'comments',
					type:'text_area',
					values:'',
					layout:'col s12',
					readonly:false,
				},
			]
		},
		{
			step:6, 
			label:'Decisiveness',
			type: 'group',
			name:'decisiveness',
			layout:'row',
			options:[
				{
					id:10,
					name:'decisiveness',
					label:'Decisiveness',
					type:'radio',
					options: [
						{
							label: '1',
							value: 1
						},
						{
							label: '2',
							value: 2
						},
						{
							label: '3',
							value: 3
						},
						{
  label: '4',
  value: 4
},
{
  label: '5',
  value: 5
},
						{
							label: 'Unable To State',
							value: 'Unable To State'
						},
					],
					values: new Object,
					readonly:false,
					layout:'col s12 clear'
				},
				{
					id:11,
					label:'Additional Comments',
					name:'comments',
					type:'text_area',
					values:'',
					layout:'col s12',
					readonly:false,
				},
			]
		},
		{
			step:7, 
			label:'Listening and Communication Skills ',
			type: 'group',
			name:'listening_communication_skills',
			layout:'row',
			options:[
				{
					id:12,
					name:'listening_communication_skills',
					label:'Listening and Communication Skills ',
					type:'radio',
					options: [
						{
							label: '1',
							value: 1
						},
						{
							label: '2',
							value: 2
						},
						{
							label: '3',
							value: 3
						},
						{
  label: '4',
  value: 4
},
{
  label: '5',
  value: 5
},
						{
							label: 'Unable To State',
							value: 'Unable To State'
						},
					],
					values: new Object,
					readonly:false,
					layout:'col s12 clear'
				},
				{
					id:13,
					label:'Additional Comments',
					name:'comments',
					type:'text_area',
					values:'',
					layout:'col s12',
					readonly:false,
				},
			]
		},
		{
			step:8, 
			label:'Authority and Keeping Abreast of Legal Developments',
			type: 'group',
			name:'authority_keeping_abreast_legal_developments',
			layout:'row',
			options:[
				{
					id:14,
					name:'authority_keeping_abreast_legal_developments',
					label:'Authority and Keeping Abreast of Legal Developments',
					type:'radio',
					options: [
						{
							label: '1',
							value: 1
						},
						{
							label: '2',
							value: 2
						},
						{
							label: '3',
							value: 3
						},
						{
  label: '4',
  value: 4
},
{
  label: '5',
  value: 5
},
						{
							label: 'Unable To State',
							value: 'Unable To State'
						},
					],
					values: new Object,
					readonly:false,
					layout:'col s12 clear'
				},
				{
					id:15,
					label:'Additional Comments',
					name:'comments',
					type:'text_area',
					values:'',
					layout:'col s12',
					readonly:false,
				},
			]
		},

		{
			step:9, 
			label:'Integrity',
			type: 'group',
			name:'integrity',
			layout:'row',
			options:[
				{
					id:16,
					name:'integrity',
					label:'Integrity',
					type:'radio',
					options: [
						{
							label: '1',
							value: 1
						},
						{
							label: '2',
							value: 2
						},
						{
							label: '3',
							value: 3
						},
						{
  label: '4',
  value: 4
},
{
  label: '5',
  value: 5
},
						{
							label: 'Unable To State',
							value: 'Unable To State'
						},
					],
					values: new Object,
					readonly:false,
					layout:'col s12 clear'
				},
				{
					id:17,
					label:'Additional Comments',
					name:'comments',
					type:'text_area',
					values:'',
					layout:'col s12',
					readonly:false,
				},
			]
		},
		{
			step:10, 
			label:'Fairness',
			type: 'group',
			name:'fairness',
			layout:'row',
			options:[
				{
					id:18,
					name:'fairness',
					label:'Fairness',
					type:'radio',
					options: [
						{
							label: '1',
							value: 1
						},
						{
							label: '2',
							value: 2
						},
						{
							label: '3',
							value: 3
						},
						{
  label: '4',
  value: 4
},
{
  label: '5',
  value: 5
},
						{
							label: 'Unable To State',
							value: 'Unable To State'
						},
					],
					values: new Object,
					readonly:false,
					layout:'col s12 clear'
				},
				{
					id:19,
					label:'Additional Comments',
					name:'comments',
					type:'text_area',
					values:'',
					layout:'col s12',
					readonly:false,
				},
			]
		},
		{
			step:11, 
			label:'Understanding People and Society',
			type: 'group',
			name:'understanding_people_society',
			layout:'row',
			options:[
				{
					id:20,
					name:'understanding_people_society',
					label:'Understanding People and Society',
					type:'radio',
					options: [
						{
							label: '1',
							value: 1
						},
						{
							label: '2',
							value: 2
						},
						{
							label: '3',
							value: 3
						},
						{
  label: '4',
  value: 4
},
{
  label: '5',
  value: 5
},
						{
							label: 'Unable To State',
							value: 'Unable To State'
						},
					],
					values: new Object,
					readonly:false,
					layout:'col s12 clear'
				},
				{
					id:21,
					label:'Additional Comments',
					name:'comments',
					type:'text_area',
					values:'',
					layout:'col s12',
					readonly:false,
				},
			]
		},
		{
			step:12, 
			label:'Maturity and Sound Temperament',
			type: 'group',
			name:'understanding_people_society',
			layout:'row',
			options:[
				{
					id:22,
					name:'understanding_people_society',
					label:'Maturity and Sound Temperament',
					type:'radio',
					options: [
						{
							label: '1',
							value: 1
						},
						{
							label: '2',
							value: 2
						},
						{
							label: '3',
							value: 3
						},
						{
  label: '4',
  value: 4
},
{
  label: '5',
  value: 5
},
						{
							label: 'Unable To State',
							value: 'Unable To State'
						},
					],
					values: new Object,
					readonly:false,
					layout:'col s12 clear'
				},
				{
					id:23,
					label:'Additional Comments',
					name:'comments',
					type:'text_area',
					values:'',
					layout:'col s12',
					readonly:false,
				},
			]
		},
		{
			step:13, 
			label:'Courtesy and Humanity',
			type: 'group',
			name:'courtesy_humanity',
			layout:'row',
			options:[
				{
					id:24,
					name:'courtesy_humanity',
					label:'Courtesy and Humanity',
					type:'radio',
					options: [
						{
							label: '1',
							value: 1
						},
						{
							label: '2',
							value: 2
						},
						{
							label: '3',
							value: 3
						},
						{
							label: '4',
							value: 4
						},
						{
							label: '5',
							value: 5
						},
						{
							label: 'Unable To State',
							value: 'Unable To State'
						},
					],
					values: new Object,
					readonly:false,
					layout:'col s12 clear'
				},
				{
					id:25,
					label:'Additional Comments',
					name:'comments',
					type:'text_area',
					values:'',
					layout:'col s12',
					readonly:false,
				},
			]
		},
		{
			step:14, 
			label:'Commitment',
			type: 'group',
			name:'commitment',
			layout:'row',
			options:[
				{
					id:26,
					name:'commitment',
					label:'Commitment',
					type:'radio',
					options: [
						{
							label: '1',
							value: 1
						},
						{
							label: '2',
							value: 2
						},
						{
							label: '3',
							value: 3
						},
						{
							label: '4',
							value: 4
						},
						{
							label: '5',
							value: 5
						},
						{
							label: 'Unable To State',
							value: 'Unable To State'
						},
					],
					values: new Object,
					readonly:false,
					layout:'col s12 clear'
				},
				{
					id:27,
					label:'Additional Comments',
					name:'comments',
					type:'text_area',
					values:'',
					layout:'col s12',
					readonly:false,
				},
			]
		},
		{
			step:15, 
			label:'Overall Marking',
			type: 'group',
			name:'overallMarking',
			layout:'row',
			options:[
				{
					id:28,
					name:'overallMarking',
					label:'Overall Marking',
					type:'radio',
					options: [
						{
							label: '1',
							value: 1
						},
						{
							label: '2',
							value: 2
						},
						{
							label: '3',
							value: 3
						},
						{
							label: '4',
							value: 4
						},			
					],
					values: new Object,
					readonly:false,
					layout:'col s12 clear'
				},
				{
					id:29,
					label:'Additional Comments',
					name:'comments',
					type:'text_area',
					values:'',
					layout:'col s12',
					readonly:false,
				},
			]
		},
		{
			step:16, 
			label:'Please give details of your overall asssessment of the officer',
			type:'text_area',
			name:'over_details',
			layout:'col s12',
			values: ''
		/* 	options:[
			
				{
					id:30,
					label:'Overall Comments',
					name:'comments',
					type:'text_area',
					values:'',
					layout:'col s12',
					readonly:false,
				},
			] */
		},
]

const generate = () =>{
	return fields 
}

export default {
	fields, generate
}